import { AppThunk } from '../../../store/rootReducer';
import * as undoActions from '../actions/undo.actions';

export const restore = (): AppThunk => async (dispatch, getState) => {
  const { undo } = getState();
  const entry = undo.restoreStack[undo.restoreStack.length - 1];

  if (entry == null) {
    return;
  }

  dispatch(
    undoActions.restore({ diff: entry.toNext, meta: { history: false } }),
  );
};
